import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box, Text } from "sprout-ui-primitives";
import { sortLabels } from "@sprout/client-lib/dist/labels_next";
import { EmptyListText } from "@sprout/client-components/dist/EmptyList";
import { getItemUrl } from "sprout-lib";
import TopicPageViewsLabelsLabels from "./TopicPageViewsLabelsLabels";
const TopicPageViewsLabelsMain = (props)=>{
    const { topic  } = props;
    const { title , labels: { nodes  } , rootTopicOrSelf ,  } = topic;
    const labels = useMemo(()=>{
        return sortLabels(nodes);
    }, [
        nodes
    ]);
    const rootURL = getItemUrl(topic, rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.owner);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                px: [
                    null,
                    3
                ],
                pb: 5,
                children: /*#__PURE__*/ _jsxs(Text, {
                    fontSize: "34px",
                    fontWeight: "bold",
                    textAlign: "center",
                    children: [
                        "All ",
                        title,
                        " Labels"
                    ]
                })
            }),
            labels.length === 0 ? /*#__PURE__*/ _jsxs(EmptyListText, {
                children: [
                    "Need to categorize leaves for easy reference? To create a label, tap",
                    " ",
                    /*#__PURE__*/ _jsx("em", {
                        children: "New"
                    }),
                    "."
                ]
            }) : /*#__PURE__*/ _jsx(TopicPageViewsLabelsLabels, {
                labels: labels,
                rootURL: rootURL
            })
        ]
    });
};
export default TopicPageViewsLabelsMain;
